import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-email',
	standalone: false,
	templateUrl: './dynamic-form-input-email.component.html',
	styleUrl: './dynamic-form-input-email.component.scss'
})
export class DynamicFormInputEmailComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;
}
